/**
 * Project-wide constants.
 *
 * Fog color + distances come from 01-AESTHETIC-BRIEF.md Rule 5 (warm-ochre ~200m).
 * Walk speed / camera height / player radius come from 03-RESEARCH.md Pattern 2.
 */
export const CAMERA_HEIGHT = 1.7; // meters, standard eye level
export const WALK_SPEED = 2.5; // m/s, leisurely stroll
export const PLAYER_RADIUS = 0.4; // meters, collision radius (Minkowski trick)

export const FOG_COLOR = '#E8D5B7'; // warm-ochre per AESTHETIC-BRIEF Rule 5
export const FOG_NEAR = 20;
export const FOG_FAR = 200; // AESTHETIC-BRIEF Rule 5: fog at ~200m

export const BOUNDARY_FEEDBACK_MS = 1500; // NAV-07 vignette duration

export const MANIFEST_URL = '/manifest/world.json';
